import React from 'react';
import HeaderButton from '../layouts/HeaderButton'
import { header } from '../../profile'

const Header = () => {

    const scrollTo = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        })
    }

   

    return (
        <div>
            <div className="Header">
                
                <h1>{ `I'm ${header.name}` }</h1>
            <p className="line-1 anim-typewriter">and technology is my playground! </p>
           
           
         
            </div>
            
        </div>
    )
    
}

export default Header;